<script lang="ts">
  import Typography from "$lib/components/Typography/Typography.svelte";
  import { createEventDispatcher } from "svelte";
  interface RadioGroup {
    name: string;
    label: string;
  }

  export let isSortBy: boolean = false;
  export let items: RadioGroup[] = [];
  export let group = "";
  export let margin = "0 15px 18px 0";
  export let light = false;

  const dispatch = createEventDispatcher();

  const onChange = (e: Event) => {
    dispatch("change", e);
  };

  if (isSortBy) {
    margin = "0";
  }
</script>

<style lang="scss">
  label {
    display: flex;
    cursor: pointer;
    position: relative;
  }

  .radio {
    display: flex;
    cursor: pointer;
    position: relative;
    background-clip: content-box;
    height: 20px;
    width: 20px;
    min-width: 20px;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    appearance: none;
    border: 1px solid $on-surface-30;
    border-radius: 100px;
    outline: none;
    transition-duration: 0.2s;
    cursor: pointer;
    padding: 0;
    margin: 0;
  }

  .radio.radio--light {
    border: 1px solid $inverse-on-surface;
  }

  input:checked {
    border: 1px solid $background;
    background-color: $on-surface;
    justify-content: center;
    padding: 4px;
  }

  input:checked.radio--light {
    border: 1px solid $inverse-on-surface;
    background-color: $inverse-on-surface;
  }

  .value {
    padding-left: 4px;
  }
</style>

{#each items as item (item)}
  <label style={isSortBy ? "height: 24px" : ""}>
    <input
      class={`radio ${light && "radio--light"}`}
      type="radio"
      bind:group
      name={item.name}
      value={item.name}
      on:change={onChange}
    />
    <div
      class="value"
      style={`margin: ${margin}; ${
        isSortBy ? "display: flex; align-items: center;" : ""
      }`}
      role="button"
      tabindex="0"
    >
      <Typography
        theme={light ? "inverse-on-surface" : "on-surface"}
        component="span"
        variant="button1">{item.label}</Typography
      >
    </div>
  </label>
{/each}
